import svgPaths from "./svg-ma5273uc9m";

function Svg() {
  return (
    <div className="absolute left-[2px] size-[20px] top-[2px]" data-name="svg_340760 1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <g clipPath="url(#clip0_4065_331)" id="svg_340760 1">
          <path d={svgPaths.p222a3580} fill="var(--fill-0, #101928)" id="Vector" />
          <path d={svgPaths.p3116fbf0} fill="var(--fill-0, #667185)" id="Vector_2" />
          <path d={svgPaths.p272f6400} fill="var(--fill-0, #667185)" id="Vector_3" />
          <path d={svgPaths.p211c2c00} fill="var(--fill-0, #E4E7EC)" id="Vector_4" />
          <path d={svgPaths.p3dc0a000} fill="var(--fill-0, #101928)" id="Vector_5" />
          <path d={svgPaths.p5986d00} fill="var(--fill-0, #667185)" id="Vector_6" />
          <path d={svgPaths.p1897bf80} fill="var(--fill-0, #E4E7EC)" id="Vector_7" />
          <path d={svgPaths.p2186da80} fill="var(--fill-0, #101928)" id="Vector_8" />
          <path d={svgPaths.p3b305d80} fill="var(--fill-0, #667185)" id="Vector_9" />
          <path d={svgPaths.p3a546200} fill="var(--fill-0, #E4E7EC)" id="Vector_10" />
          <path d={svgPaths.p3e48500} fill="var(--fill-0, #E4E7EC)" id="Vector_11" />
          <path d={svgPaths.p35f3d00} fill="var(--fill-0, #667185)" id="Vector_12" />
          <path d={svgPaths.p122aab00} fill="var(--fill-0, #E4E7EC)" id="Vector_13" />
          <g id="<Transparent Rectangle>"></g>
        </g>
        <defs>
          <clipPath id="clip0_4065_331">
            <rect fill="white" height="20" width="20" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default function Opacity() {
  return (
    <div className="overflow-clip relative rounded-[4px] size-full" data-name="Opacity">
      <Svg />
    </div>
  );
}
